module.exports = __webpack_public_path__ + "static/img/m_name.a4dc7df.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/mz/m_name.png
// module id = nuEv
// module chunks = 7